import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { ProgressBarsStriped } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PROGRESS_STRIPED_DATA, PROGRESS_STRIPED_LIST } from "../../../../Data/UiKit/Progress/index";

export const ProgressBarsStripedCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ProgressBarsStriped} span={PROGRESS_STRIPED_DATA} />
        <Row className="card-body progress-showcase">
          <Col>
            <Progressbar color="primary" striped value="10" />
            {PROGRESS_STRIPED_LIST.map(({ color, value }, index) => (
              <Progressbar color={color} striped value={value} key={index} />
            ))}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
